const Hero = () => {
    return (
        <section id='hero' className='d-flex align-items-center'>
            <div className='container' data-aos='zoom-out' data-aos-delay='100'>
                <div className='row'>
                    <div className='col-xl-7'>
                        <h1>Trasporti e Noleggio a Roma</h1>
                        <h2 className='h4'>
                            Cerchi autocarri, gru o sollevatori a Roma?
                            <span className='labelBoldNoWrap d-block'>Marrone S.r.l. fa per te!</span>
                        </h2>
                        <a href='#contact' className='btn-get-started'>
                            Contattaci
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default Hero;
